import { IStoreAction, STORE } from '../generalTypes'
import { ICurrentUserAction, ICurrentUserLoadDetailPayload } from './currentUserActions'
import { CURRENT_USER_LOAD_DETAIL } from './currentUserTypes'

const initState: {
	detail: ICurrentUserLoadDetailPayload
} = {
	detail: {
		record: undefined,
		isLoading: false,
		isFailure: false
	}
}

export default (state = initState, action: ICurrentUserAction | IStoreAction) => {
	switch (action.type) {
		case CURRENT_USER_LOAD_DETAIL.START:
			return {
				...state,
				detail: {
					...state.detail,
					isLoading: true,
					isFailure: false
				}
			}
		case CURRENT_USER_LOAD_DETAIL.DONE:
			return {
				...state,
				detail: {
					...state.detail,
					...action.payload,
					isLoading: false,
					isFailure: false
				}
			}
		case CURRENT_USER_LOAD_DETAIL.FAIL:
			return {
				...state,
				detail: {
					...state.detail,
					isLoading: false,
					isFailure: true
				}
			}
		case STORE.RESET:
			return initState
		default:
			return state
	}
}
